/** Priority and label marks of a team (#2872): on a tile and in the table. "Normal" shows faintly. */
import { ChevronDown, ChevronsUp } from "lucide-react";
import type { AdminAllTeamsRow } from "../../../api/useAdminTeams";
import { cn } from "../../../lib/cn";
import { priorityOf, priorityWords } from "./teamOrder";

export function PriorityMark({ row, className }: { row: AdminAllTeamsRow; className?: string }) {
  const p = priorityOf(row);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 whitespace-nowrap",
        p === "high" && "font-semibold text-fg",
        p === "normal" && "text-fg-faint",
        p === "low" && "text-fg-muted",
        className,
      )}
      data-priority={p}
    >
      {p === "high" ? <ChevronsUp className="h-3.5 w-3.5" aria-hidden="true" /> : null}
      {p === "low" ? <ChevronDown className="h-3.5 w-3.5" aria-hidden="true" /> : null}
      {priorityWords(row)}
    </span>
  );
}

/** The label, cut short with the full text in `title`. Nothing when the team has none. */
export function LabelMark({ row, className }: { row: AdminAllTeamsRow; className?: string }) {
  const label = row.admin_label?.trim();
  if (!label) return null;
  return (
    <span
      className={cn("inline-block max-w-[10rem] truncate align-bottom", className)}
      title={label}
      data-label=""
    >
      {label}
    </span>
  );
}
